import clsx from 'clsx';
import styles from './styles.module.scss';

export const ContentsHeader = ({
  title,
  description = '',
  actions = null,
  isSubContents = false,
}: {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  isSubContents?: boolean;
}) => {
  return (
    <div className={clsx(styles.Header, isSubContents && styles.subHeader)}>
      <div className={styles.Header__TitleContainer}>
        <h1 className={clsx(styles.Header__Title, isSubContents && styles.subHeaderTitle)}>
          {title}
        </h1>
        {description && <div className={styles.Header__Description}>{description}</div>}
      </div>
      <div className={styles.Header__Actions}>{actions}</div>
    </div>
  );
};
